import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {NewVulnerabilityService} from '../Data Service/new-vulnerability.service'
import { errorClass } from "./errorClass";

@Injectable({
    providedIn: 'root'
})

export class HttpErrorService implements HttpInterceptor{
    errorCl = new errorClass();
    constructor(private service : NewVulnerabilityService,private _router : Router){}

    intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
        // console.log('HTTP Request started');
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    const errorMessage = this.setError(error);
                    console.log("Err generated : "+errorMessage);
                    //this.errorCl.ExceptionMessage = errorMessage;
                    //this.errorCl.ExceptionURL = error.url;
                    //this.errorCl.ExceptionStatus = error.status;
                    this.errorCl.ExceptionType = error.type;
                    console.log("test"+error.type);
                    var val = {
                        ExceptionMessage : errorMessage,
                        ExceptionURL : error.url,
                        ExceptionStatus : error.status,
                        ExceptionType : error.type
                    };
                    
                    this.service.addError(val).subscribe(res => {
                         //this._router.navigate(['/home']);
                     });
                     const errormessage="Something bad happened,Please try after sometime." 
                                      
                    return throwError(errormessage);
                })
            );
    }

    setError(error: HttpErrorResponse): string {
        let errorMessage = 'Unknown error occured';
        console.log("SetErr : "+error.status);
        //console.log("SetErr status : "+error.error.message);
        //errorMessage = error.error.message;
        // if(error.error instanceof HttpResponse) {
        //     // Client side error
        //     console.log("instance :"+error.error);
        //     errorMessage = error.statusText;
        // } else {
        //     // server side error
        //     console.log("instance1 :"+error.statusText);
        //     if (error.status!==0) {
        //         errorMessage = error.statusText;
        //     }
        // }

        switch (error.status) {
            case 404: {
                return `Not Found: ${error.message}`;
            }
            case 403: {
                return `Access Denied: ${error.message}`;
            }
            case 500: {
                return `Internal Server Error: ${error.message}`;
            }
            default: {
                return `Unknown Server Error: ${error.message}`;
            }
        }
        console.log("SetErr1 : "+ errorMessage);
        //return errorMessage;
    }
}